import React, { useEffect, useRef } from 'react'

import { LeftArrow, RightArrow } from 'components/common'
import s from './ScrollableList.module.css'

const ScrollableList = ({ items, children, services }) => {
  const rightBtnRef = useRef(null)
  const leftBtnRef = useRef(null)

  const scrollListTopWrapperRef = useRef(null)
  const scrollListTopRef = useRef(null)

  useEffect(() => {
    const scrollListTopWrapper = scrollListTopWrapperRef.current
    const scrollListTop = scrollListTopRef.current

    scrollHandler(-99999)

    if (scrollListTopWrapper.offsetWidth >= scrollListTop.scrollWidth) {
      rightBtnRef.current.classList.add(s.hideBtn)
      leftBtnRef.current.classList.add(s.hideBtn)
    } else {
      rightBtnRef.current.classList.remove(s.hideBtn)
      leftBtnRef.current.classList.add(s.hideBtn)
    }
  }, [services])

  const scrollHandler = (scrollOffset) => {
    const scrollListTopWrapper = scrollListTopWrapperRef.current
    const scrollListTop = scrollListTopRef.current

    scrollListTopWrapper.scrollLeft += scrollOffset
    scrollListTop.scrollLeft += scrollOffset
  }

  return (
    <div
      className={s.scrollListTop}
      id="scroll-list-top-wrapper"
      ref={scrollListTopWrapperRef}
    >
      <button
        className={s.scrollLeftBtn}
        ref={leftBtnRef}
        onClick={() => {
          scrollHandler(-150)

          const scrollListTopWrapper = document.getElementById(
            'scroll-list-top-wrapper'
          )

          rightBtnRef.current.classList.remove(s.hideBtn)

          if (scrollListTopWrapper.scrollLeft === 0) {
            leftBtnRef.current.classList.add(s.hideBtn)
          }
        }}
      >
        <LeftArrow width={10} height={10} />
      </button>

      <div className={s.services} id="scroll-list-top" ref={scrollListTopRef}>
        {children}

        <div className="relative h-[94px] flex-1 flex items-center justify-center pr-6">
          {items?.length ? (
            <ul className={s.listItems}>{items}</ul>
          ) : (
            <div className="mx-auto flex justify-center flex-1">
              {/* There is no any services in this region for now */}
            </div>
          )}
        </div>
      </div>

      <button
        className={s.scrollRightBtn}
        ref={rightBtnRef}
        onClick={() => {
          scrollHandler(150)

          const scrollListTopWrapper = document.getElementById(
            'scroll-list-top-wrapper'
          )

          leftBtnRef.current.classList.remove(s.hideBtn)

          if (
            scrollListTopWrapper.scrollLeft +
              scrollListTopWrapper.clientWidth >=
            scrollListTopWrapper.scrollWidth
          ) {
            rightBtnRef.current.classList.add(s.hideBtn)
          }
        }}
      >
        <RightArrow width={10} height={10} />
      </button>
    </div>
  )
}

export default ScrollableList
